import { TAuth } from "@Reducers/Authentication.reducer";
import { createContext } from "react";

const AuthenticationContext = createContext<TAuth>({
  isLoading: false,
  attributes: null,
  isAuthenticated: false,
  login: () => {
    return null;
  },
  logout: () => {
    return null;
  },
  restoreToken: () => {
    return null;
  },
  initialize: () => {
    return null;
  },
});

export default AuthenticationContext;
